module.exports = __webpack_public_path__ + "img/class2.d3a7dd87.png";